/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import type { Calendar } from './Calendar';
/**
 * 
 * @export
 * @interface Exercise
 */
export interface Exercise {
    /**
     * 
     * @type {number}
     * @memberof Exercise
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof Exercise
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof Exercise
     */
    contentfulProgramId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Exercise
     */
    contentfulSubjectId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Exercise
     */
    contentfulWeekId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Exercise
     */
    contentfulSessionId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Exercise
     */
    timeSpent?: number;
    /**
     * 
     * @type {number}
     * @memberof Exercise
     */
    userId?: number;
    /**
     * 
     * @type {Date}
     * @memberof Exercise
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Exercise
     */
    modified?: Date | null;
    /**
     * 
     * @type {Calendar}
     * @memberof Exercise
     */
    dateNavigation?: Calendar;
    /**
     * 
     * @type {User}
     * @memberof Exercise
     */
    user?: User;
}

/**
 * Check if a given object implements the Exercise interface.
 */
export function instanceOfExercise(value: object): value is Exercise {
    return true;
}

export function ExerciseFromJSON(json: any): Exercise {
    return ExerciseFromJSONTyped(json, false);
}

export function ExerciseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Exercise {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'contentfulProgramId': json['contentfulProgramId'] == null ? undefined : json['contentfulProgramId'],
        'contentfulSubjectId': json['contentfulSubjectId'] == null ? undefined : json['contentfulSubjectId'],
        'contentfulWeekId': json['contentfulWeekId'] == null ? undefined : json['contentfulWeekId'],
        'contentfulSessionId': json['contentfulSessionId'] == null ? undefined : json['contentfulSessionId'],
        'timeSpent': json['timeSpent'] == null ? undefined : json['timeSpent'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'modified': json['modified'] == null ? undefined : (new Date(json['modified'])),
        'dateNavigation': json['dateNavigation'] == null ? undefined : (require('./Calendar') as typeof import('./Calendar')).CalendarFromJSON(json['dateNavigation']),
        'user': json['user'] == null ? undefined : (require('./User') as typeof import('./User')).UserFromJSON(json['user']),
    };
}

export function ExerciseToJSON(json: any): Exercise {
    return ExerciseToJSONTyped(json, false);
}

export function ExerciseToJSONTyped(value?: Exercise | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'contentfulProgramId': value['contentfulProgramId'],
        'contentfulSubjectId': value['contentfulSubjectId'],
        'contentfulWeekId': value['contentfulWeekId'],
        'contentfulSessionId': value['contentfulSessionId'],
        'timeSpent': value['timeSpent'],
        'userId': value['userId'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'modified': value['modified'] == null ? value['modified'] : value['modified'].toISOString(),
        'dateNavigation': (require('./Calendar') as typeof import('./Calendar')).CalendarToJSON(value['dateNavigation']),
        'user': (require('./User') as typeof import('./User')).UserToJSON(value['user']),
    };
}

